// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2BTHJ","topBottomGutter":"Layout_topBottomGutter__1h3oX"};